import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const Laurel = t0 => {
  const $ = _c(11);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      strokeWidth: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const strokeWidth = t1 === undefined ? 1 : t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M15.81 21.49C10.47 19.44 8.93 10.75 13.4 5.98" strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M12.56 18.88C11.23 20.04 9.02 19.45 7.98 17.65C9.78 16.61 11.99 17.2 12.56 18.88Z" strokeLinecap="round" strokeLinejoin="round" />;
    t4 = <path d="M10.94 14.76C9.23 15.23 7.51 13.73 7.36 11.65C9.44 11.51 11.16 13.01 10.94 14.76Z" strokeLinecap="round" strokeLinejoin="round" />;
    t5 = <path d="M11.15 10.13C9.4 9.86 8.43 7.79 9.15 5.83C11.1 6.55 12.07 8.62 11.15 10.13Z" strokeLinecap="round" strokeLinejoin="round" />;
    t6 = <path d="M13.4 5.98C13 4.26 14.56 2.58 16.64 2.51C16.71 4.59 15.15 6.26 13.4 5.98Z" strokeLinecap="round" strokeLinejoin="round" />;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[8] !== props || $[9] !== strokeWidth) {
    t7 = <IconWrapper {...props} strokeWidth={strokeWidth} variant="outline">{t2}{t3}{t4}{t5}{t6}</IconWrapper>;
    $[8] = props;
    $[9] = strokeWidth;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};
export { Laurel };